
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';


export class CheckboxWidget extends Component {

  static propTypes = {
    value: PropTypes.any,
    onChange: PropTypes.func.isRequired,
    label: PropTypes.string,
  };

  handleChange = (e) => {
    const { onChange } = this.props;
    const value = e.target.checked;
    onChange(value);
  };

  render() {
    const { label, ...props } = this.props;
    let value = this.props.value;

    if (typeof value === 'string') {
      switch (value) {
        case 'true':
          value = true;
          break;
        default:
          value = false;
      }
    }
    else if (typeof value !== 'boolean') {
        value = false;
    }

    return (
      <FormControlLabel
        control={
          <Checkbox checked={value} onChange={(e) => this.handleChange(e)}  />
        }
        label={label}
        {...props}
      />
    )
  }
}

export class Checkbox2 extends Component {

  static propTypes = {
    value: PropTypes.any,
    onChange: PropTypes.func.isRequired,
  };

  handleChange = (e) => {
    const { onChange } = this.props;
    const value = e.target.checked;
    onChange(value);
  };

  render() {
    let { value, ...props } = this.props;

    if (typeof value === 'string') {
      switch (value) {
        case 'true':
          value = true;
          break;
        default:
          value = false;
      }
    }
    else if (typeof value !== 'boolean') {
        value = false;
    }

    return (
      <Checkbox
        checked={value}
        onChange={(e) => this.handleChange(e)}
        {...props}
      />
    )
  }
}
